import Point from "../rooms/point";

const treePoints: Point[] = [
  { coordinateX: 0, coordinateY: 5 },
  { coordinateX: 2, coordinateY: 2 },
  { coordinateX: 1, coordinateY: 2 },
  { coordinateX: 4, coordinateY: -3 },
  { coordinateX: 1, coordinateY: -3 },
  { coordinateX: 1, coordinateY: -4 },
  { coordinateX: -1, coordinateY: -4 },
  { coordinateX: -1, coordinateY: -3 },
  { coordinateX: -4, coordinateY: -3 },
  { coordinateX: -1, coordinateY: 2 },
  { coordinateX: -2, coordinateY: 2 },
];

const starPoints: Point[] = [
  { coordinateX: 0, coordinateY: 4 },
  { coordinateX: 1, coordinateY: 1 },
  { coordinateX: 4.3, coordinateY: 1 },
  { coordinateX: 1.5, coordinateY: -0.8 },
  { coordinateX: 2.7, coordinateY: -4 },
  { coordinateX: 0, coordinateY: -2 },
  { coordinateX: -2.7, coordinateY: -4 },
  { coordinateX: -1.5, coordinateY: -0.8 },
  { coordinateX: -4.3, coordinateY: 1 },
  { coordinateX: -1, coordinateY: 1 },
];

export { starPoints, treePoints };
